import { Money } from 'finhelper';

/** Максимум знаков после запятой при отсечении (не округление), если целая часть нулевая. */
const MAX_FRACTION_DIGITS = 8;

function numberToPlainString(value: number): string {
  if (!Number.isFinite(value)) return '';
  let s = value.toString();
  if (/e/i.test(s)) {
    const plain = Math.abs(value).toFixed(20);
    return value < 0 ? `-${plain}` : plain;
  }
  return s;
}

/** Приводит вход к строке вида `[-]целая[.дробная]` без пробелов; запятая как десятичный разделитель. */
function normalizeInput(value: string | number): string {
  if (typeof value === 'number') {
    return numberToPlainString(value);
  }
  let s = String(value)
    .trim()
    .replace(/[\s\u00A0]/g, '')
    .replace(',', '.');
  if (s.startsWith('+')) {
    s = s.slice(1);
  }
  return s;
}

/** Спец-форматтер цены для инвестиций. */
export function formatInvestDecimalDisplay(value: string | number | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }

  const raw = normalizeInput(value);
  if (raw === '' || raw === '-') {
    return raw;
  }

  const negative = raw.startsWith('-');
  let body = negative ? raw.slice(1) : raw;

  const dotIdx = body.indexOf('.');
  let intPart: string;
  let fracPart: string;

  if (dotIdx === -1) {
    intPart = body === '' ? '0' : body;
    fracPart = '';
  } else {
    intPart = body.slice(0, dotIdx);
    fracPart = body.slice(dotIdx + 1).replace(/\./g, '');
    if (intPart === '') {
      intPart = '0';
    }
  }

  if (intPart.length > 1) {
    intPart = intPart.replace(/^0+/, '') || '0';
  }

  const sign = negative ? '-' : '';
  const normalized = fracPart === '' ? sign + intPart : `${sign}${intPart}.${fracPart}`;

  switch (true) {
    // Спец-ветка: маленькие дробные числа 0.xxx -> до 8 знаков без округления, убираем хвостовые нули.
    case intPart === '0': {
      let smallFrac = fracPart;
      if (smallFrac.length > MAX_FRACTION_DIGITS) {
        smallFrac = smallFrac.slice(0, MAX_FRACTION_DIGITS);
      }
      smallFrac = smallFrac.replace(/0+$/, '');
      return smallFrac === '' ? sign + intPart : `${sign}${intPart}.${smallFrac}`;
    }
    // Все остальные случаи — общий денежный форматтер.
    default:
      return Money.format(normalized);
  }
}
